// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

import { useToastStore, Toast, ToastType } from "@/stores/toast";

// -----------------------------------------------------------------------------

/**
 * Add or update the same loading toast in place, so repeated progress updates
 * for the same run don't stack up as separate toasts.
 */
export const upsertLoadingToast = (
	id: string,
	data: { title: string; message: string },
	extra: Partial<Toast> = {}
) => {
	const toasts = useToastStore();
	const payload = { type: "loading" as ToastType, ...data };

	if (toasts.toasts.some((t) => t.id === id)) {
		toasts.update(id, payload);
	} else {
		toasts.add({ id, dismissible: true, ...extra, ...payload });
	}
};

/**
 * Drop the loading toast and add a fresh terminal toast in its place.
 */
export const replaceWithTerminalToast = (
	loadingId: string,
	terminalId: string,
	data: Pick<Toast, "type" | "title" | "message" | "timeout" | "onClick">,
	extra: Partial<Toast> = {}
) => {
	const toasts = useToastStore();
	toasts.remove(loadingId);
	toasts.add({ id: terminalId, dismissible: true, ...extra, ...data });
};
